const DEFAULT_SENTRY_DSN =
  'https://e9a33eece4055b95b7b9f1dc1ee35637@o4511666141921280.ingest.us.sentry.io/4511666152407040';

export function isProductionEnv() {
  return process.env.APP_ENV === 'production';
}

export function isClientProductionEnv() {
  return process.env.NEXT_PUBLIC_APP_ENV === 'production';
}

export function getSentryDsn() {
  return (
    process.env.SENTRY_DSN ||
    process.env.NEXT_PUBLIC_SENTRY_DSN ||
    DEFAULT_SENTRY_DSN
  );
}

export function getSentryTracesSampleRate() {
  const raw =
    process.env.SENTRY_TRACES_SAMPLE_RATE ||
    process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ||
    '0.1';
  const parsed = Number.parseFloat(raw);

  return Number.isFinite(parsed) ? parsed : 0.01;
}

export function getServerSentryInitOptions() {
  const enabled = isProductionEnv();

  return {
    enabled,
    dsn: enabled ? getSentryDsn() : undefined,
    tracesSampleRate: enabled ? getSentryTracesSampleRate() : 0,
    enableLogs: enabled,
  };
}

export function getClientSentryInitOptions() {
  const enabled = isClientProductionEnv();

  return {
    enabled,
    dsn: enabled ? getSentryDsn() : undefined,
    tracesSampleRate: enabled ? getSentryTracesSampleRate() : 0,
    enableLogs: enabled,
    replaysSessionSampleRate: enabled ? 0.1 : 0,
    replaysOnErrorSampleRate: enabled ? 1.0 : 0,
  };
}
